import { TABLE_VIEW_MODES } from 'src/app/extensions/constants/commonConstants';

export const ROUTES = {
  DEFAULT_ROUTE_URL: 'dashboards',
  ADMIN_DEFAULT_ROUTE_URL: 'client-requests',
  UNAUTHORIZED_ROUTE_URL: 'unauthorized',
  SHOULD_LOGIN_ROUTE_URL: 'should-login',
  INVALID_ACCOUNT: 'invalid-account',
  AUTHENTICATION: 'authentication',
  LOGOUT: 'logout',
};

export const TABLE_VIEW_MODES_ROUTES_MAP = {
  adminUsers: TABLE_VIEW_MODES.LIST_VIEW,
  users: TABLE_VIEW_MODES.LIST_VIEW,
  emails: TABLE_VIEW_MODES.CARDS_VIEW,
  'client-requests': TABLE_VIEW_MODES.LIST_VIEW,
  contracts: TABLE_VIEW_MODES.CARDS_VIEW,
  invoices: TABLE_VIEW_MODES.LIST_VIEW,
  payments: TABLE_VIEW_MODES.LIST_VIEW,
  'asset-list': TABLE_VIEW_MODES.LIST_VIEW,
  insurances: TABLE_VIEW_MODES.LIST_VIEW,
  AdminSpecialOffers: TABLE_VIEW_MODES.LIST_VIEW,
};

export const SPECIAL_OFFER_ROUTES = {
  ADMIN_SPECIAL_OFFERS: 'adminSpecialOffers',
  SPECIAL_OFFERS: 'specialOffers',
  CAMPAIGN_DETAILS: 'campaignDetails',
  FINANCING_DETAILS: 'financingDetails',
  CAMPAIGN_DESCRIPTION: 'campaignDescription',
  CLIENT_SEGMANTATION: 'clientSegmentation',
  PREVIEW: 'preview',
  CAMPAIGN_PUBLISHED: 'campaignPublished',
  SPECIAL_OFFER_REQUESTED: 'specialOfferRequested',
  NEW: 'new',
};
